import { useQuery } from "@tanstack/react-query";
import { getApiData } from "../helpers/FleetServiceAxiosInstance";

interface IUseGetHook {
  queryKey: string[];
  url: string;
  params: any;
}

const useFleetServiceGetHook = (props: IUseGetHook) => {
  const { queryKey, url, params } = props;
  const { isLoading, isError, data, isSuccess, refetch } = useQuery(
    queryKey,
    async () => {
      const response = await getApiData(url, params);
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      keepPreviousData: true,
    }
  );

  return { isLoading, isError, data, isSuccess, refetch };
};

export default useFleetServiceGetHook;
